import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProjects } from "../../../store/slices/projectsSlice";
import {
  setSelectedProjectName,
  setSelectedTaskId,
} from "../../../store/slices/ProjectOngoing/taskScrollSlice";
import {
  setSelectedTabProjectApproved,
  setSelectedTabProjectAssign,
  setSelectedTabProjectComplete,
  setSelectedTabProjectRequest,
  setSelectedTabState,
} from "../../../store/slices/OperationSlices/operationStateSlice";
import { useLoggedUser } from "../../../utils/useLoggedUser";

const TaskInHand = ({
  ongoingEntries1,
  ongoingEntries,
  ongoingHardwareParts1,
  ongoingHardwareParts: ongoingHardwarePartsProp,
  ongoingOpProjectsState1,
  ongoingOpProjectsState,
  isInteractionDisabled = false,
  onInteractionDisabled,
  isViewOnly = false,
}) => {
  const isCrmLocked = isInteractionDisabled && !isViewOnly;
  const handleRowClickWhenAllowed = (callback) => {
    if (isInteractionDisabled) {
      if (typeof onInteractionDisabled === "function") {
        onInteractionDisabled();
      }
    }
    callback();
  };

  const loggedUser = useLoggedUser();

  console.log("TaskInHand ongoingEntries1", ongoingEntries1);
  console.log("TaskInHand ongoingHardwareParts1", ongoingHardwareParts1);
  console.log("TaskInHand ongoingOpProjectsState1", ongoingOpProjectsState1);
  console.log("TaskInHand loggedUser?.EmpAuthLevel", loggedUser?.EmpAuthLevel);

  const dispatch = useDispatch();
  const [taskList, setTaskList] = useState([]);

  const ongoingWorkentries = useSelector(
    (state) => state.operationFeature.ongoingWorkentries
  );
  const ongoingProjectsRedux = useSelector(
    (state) => state.operationFeature.ongoingProjectsRedux
  );
  const ongoingHardwareParts = useSelector(
    (state) => state.operationFeature.ongoingHardwareParts
  );
  console.log("TaskInHand1 ongoingWorkentries", ongoingWorkentries);
  console.log("TaskInHand1 ongoingProjectsRedux", ongoingProjectsRedux);
  console.log("TaskInHand1 ongoingHardwareParts", ongoingHardwareParts);
  console.log("TaskInHand1 taskList", taskList);

  const entriesFromProps = useMemo(
    () => ongoingEntries1 ?? ongoingEntries ?? [],
    [ongoingEntries1, ongoingEntries]
  );
  const hardwareFromProps = useMemo(
    () => ongoingHardwareParts1 ?? ongoingHardwarePartsProp ?? [],
    [ongoingHardwareParts1, ongoingHardwarePartsProp]
  );
  const projectsFromProps = useMemo(
    () => ongoingOpProjectsState1 ?? ongoingOpProjectsState ?? [],
    [ongoingOpProjectsState1, ongoingOpProjectsState]
  );

  useEffect(() => {
    dispatch(fetchAllProjects());
  }, [dispatch]);

  useEffect(() => {
    if (loggedUser?.EmpAuthLevel === "L4" && loggedUser?.customRoles?.includes("project manager")) {
      if (
        (Array.isArray(ongoingWorkentries) && ongoingWorkentries.length > 0) ||
        (Array.isArray(ongoingHardwareParts) && ongoingHardwareParts.length > 0)
      ) {
        const sortedEntries = [
          ...(Array.isArray(ongoingWorkentries) ? ongoingWorkentries : []),
          ...(Array.isArray(ongoingHardwareParts) ? ongoingHardwareParts : []),
        ].sort((a, b) => (a.projectid || "").localeCompare(b.projectid || ""));
        const filteredEntries = sortedEntries?.filter(
          (entry) => !entry?.isTaskComplete
        );
        const onlyTwenty = [...filteredEntries]?.slice(0, 20);
        setTaskList(onlyTwenty);
      } else {
        setTaskList([]);
      }
    } else if (loggedUser?.EmpAuthLevel === "L4" && loggedUser?.customRoles?.includes("operations")) {
      if (
        (Array.isArray(ongoingWorkentries) && ongoingWorkentries.length > 0) ||
        (Array.isArray(ongoingHardwareParts) && ongoingHardwareParts.length > 0)
      ) {
        const sortedEntries = [
          ...(Array.isArray(ongoingWorkentries) ? ongoingWorkentries : []),
          ...(Array.isArray(ongoingHardwareParts) ? ongoingHardwareParts : []),
        ].sort((a, b) => (a.projectid || "").localeCompare(b.projectid || ""));
        const filteredEntries = sortedEntries?.filter(
          (entry) => !entry?.isTaskComplete
        );
        const loggedEmpLeads = filteredEntries?.filter(
          (entry) => entry?.taskownerid === loggedUser?._id
        );
        const onlyTwenty = [...loggedEmpLeads]?.slice(0, 20);
        setTaskList(onlyTwenty);
      } else {
        setTaskList([]);
      }
    } else if (loggedUser?.EmpAuthLevel === "L3" || loggedUser?.EmpAuthLevel === "L0" || loggedUser?.EmpAuthLevel === "L1") {
      // L3 (salesperson), L0 (admin), L1 (director): one row per project group from "project ongoing", same table (Project Name + Status)
      if (Array.isArray(ongoingOpProjectsState1) && ongoingOpProjectsState1.length > 0) {
        const projectRows = ongoingOpProjectsState1.map((group) => {
          const allComplete =
            group.Projects?.every((proj) =>
              proj.Assignedperson?.every((person) => person?.isProjectComplete === true)
            ) ?? false;
          const status = allComplete ? "completed" : "pending";
          const firstProject = group.Projects?.[0];
          const syntheticEntry = firstProject
            ? { projectid: firstProject._id, _id: group.quotationId || group._key || firstProject._id }
            : null;
          return {
            projectName: group.ProjectName || "",
            assignedGroup: group.AssignedGroup || "",
            quotationId: group.quotationId,
            status,
            selectionKey:
              group.quotationId != null && String(group.quotationId).trim() !== ""
                ? `q:${String(group.quotationId).trim()}`
                : `pg:${String(group.ProjectName || "").trim().toLowerCase()}||${String(group.AssignedGroup || "").trim().toLowerCase()}`,
            syntheticEntry,
          };
        });
        setTaskList(projectRows);
      } else {
        setTaskList([]);
      }
    } else {
      if (
        (Array.isArray(entriesFromProps) && entriesFromProps.length > 0) ||
        (Array.isArray(hardwareFromProps) && hardwareFromProps.length > 0)
      ) {
        const sortedEntries = [
          ...(Array.isArray(entriesFromProps) ? entriesFromProps : []),
          ...(Array.isArray(hardwareFromProps)
            ? hardwareFromProps
            : []),
        ].sort((a, b) => (a.projectid || "").localeCompare(b.projectid || ""));
        const filteredEntries = sortedEntries?.filter(
          (entry) => !entry?.isTaskComplete
        );
        const onlyTwenty = [...filteredEntries]?.slice(0, 20);
        setTaskList(onlyTwenty);
      } else {
        setTaskList([]);
      }
    }
  }, [
    ongoingWorkentries,
    ongoingHardwareParts,
    loggedUser,
    entriesFromProps,
    hardwareFromProps,
    projectsFromProps,
    ongoingOpProjectsState1,
  ]);

  const getProjectName = (entry) => {
    if (loggedUser?.EmpAuthLevel === "L4") {
      const allProjects = Array.isArray(ongoingProjectsRedux) && ongoingProjectsRedux.length > 0
        ? ongoingProjectsRedux
        : (Array.isArray(projectsFromProps) ? projectsFromProps : []);
      const matchedProject = allProjects?.find(
        (proj) => proj?._id === entry?.projectid
      );
      return matchedProject?.ProjectName;
    } else if (loggedUser?.EmpAuthLevel === "L3") {
      const allProjects = ongoingProjectsRedux?.flatMap(
        (item) => item?.Projects || []
      );
      const matchedProject = allProjects?.find(
        (proj) => proj?._id === entry?.projectid
      );
      return matchedProject?.ProjectName;
    } else {
      const allProjects = projectsFromProps?.flatMap(
        (item) => item?.Projects || []
      );
      const matchedProject = allProjects?.find(
        (proj) => proj?._id === entry?.projectid
      );
      return matchedProject?.ProjectName;
    }
  };

  const getProjectNameSales = (entry) => {
    if (!entry?.projectid) return "";

    if (
      !Array.isArray(ongoingOpProjectsState1) ||
      ongoingOpProjectsState1.length === 0
    ) {
      return "";
    }

    const allProjects = ongoingOpProjectsState1?.flatMap(
      (item) => item?.Projects || []
    );
    const matchedProject = allProjects?.find(
      (proj) => proj?._id === entry?.projectid
    );
    return matchedProject?.ProjectName || "";
  };

  return (
    <div className="bg-white rounded-md min-h-[22rem]">
      <div className="max-w-md mx-auto px-3 pt-3">
        {/* Header */}
        <div className="bg-[#E8E8E8] text-black border border-gray-400 text-center px-1 py-2 rounded-t-md shadow-md text-lg font-semibold min-w-[200px] overflow-x-auto">
          Ongoing Tasks In Hand
        </div>

        {/* Table */}
        <div className="max-h-[18rem] min-w-[200px] max-w-auto overflow-y-auto overflow-x-auto custom-scroll border-l border-r border-gray-400">
          <table className="w-full min-w-[200px] overflow-x-auto border-r border-b border-gray-400">
            <thead>
              <tr className="bg-[#e8e8e8] text-black  text-xs font-semibold sticky top-0">
                <th className=" border-b border-gray-400 px-3 py-2 text-start">
                  Project Name
                </th>
                <th className="border-l border-b border-r border-gray-400 px-3 py-2 text-start">
                  {(loggedUser?.EmpAuthLevel === "L3" || loggedUser?.EmpAuthLevel === "L0" || loggedUser?.EmpAuthLevel === "L1") ? "Status" : "Task Description"}
                </th>
              </tr>
            </thead>
            <tbody className="">
              {(loggedUser?.EmpAuthLevel === "L3" || loggedUser?.EmpAuthLevel === "L0" || loggedUser?.EmpAuthLevel === "L1") ? (
                taskList.length > 0 ? (
                  taskList.map((row) => (
                    <tr
                      onClick={() =>
                      handleRowClickWhenAllowed(() => {
                          if (!row.syntheticEntry) return;
                          dispatch(setSelectedTabState("projectOngoing"));
                          dispatch(setSelectedTabProjectRequest(false));
                          dispatch(setSelectedTabProjectApproved(false));
                          dispatch(setSelectedTabProjectAssign(false));
                          dispatch(setSelectedTabProjectComplete(false));
                          dispatch(setSelectedProjectName(row.selectionKey || getProjectNameSales(row.syntheticEntry)));
                          dispatch(setSelectedTaskId(row.syntheticEntry));
                        })
                      }
                      key={row.quotationId ?? row.projectName ?? row.syntheticEntry?._id}
                      className={`${isInteractionDisabled ? "cursor-default" : "cursor-pointer"} bg-white text-xs font-semibold`}
                    >
                      <td
                        className="border px-3 py-2 text-start"
                        data-quotation-id={row.quotationId != null ? row.quotationId : undefined}
                      >
                        {row.projectName || "—"}
                      </td>
                      <td
                        className={`border px-3 py-2 text-start capitalize ${
                          isCrmLocked
                            ? "bg-gray-200 text-gray-700"
                            : row.status === "completed"
                            ? "bg-green-200 text-green-900"
                            : "bg-yellow-200 text-yellow-900"
                        }`}
                      >
                        {isCrmLocked ? "-" : row.status === "completed" ? "Completed" : "Pending"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="2"
                      className="border px-3 py-4 text-center text-gray-500"
                    >
                      No tasks found
                    </td>
                  </tr>
                )
              ) : taskList.length > 0 ? (
                taskList.map((entry) => (
                  <tr
                    onClick={() =>
                      handleRowClickWhenAllowed(() => {
                        dispatch(setSelectedTabState("projectOngoing"));
                        dispatch(setSelectedTabProjectRequest(false));
                        dispatch(setSelectedTabProjectApproved(false));
                        dispatch(setSelectedTabProjectAssign(false));
                        dispatch(setSelectedTabProjectComplete(false));
                        dispatch(setSelectedProjectName(getProjectName(entry)));
                        dispatch(setSelectedTaskId(entry));
                      })
                    }
                    key={entry._id}
                    className={`${isInteractionDisabled ? "cursor-default" : "cursor-pointer"} bg-white text-xs font-semibold`}
                  >
                    <td className="border px-3 py-2 text-start">
                      {getProjectName(entry)}
                    </td>
                    <td className={`border px-3 py-2 text-start ${isCrmLocked ? "bg-gray-200 text-gray-700" : ""}`}>
                      {isCrmLocked ? "-" : (entry.assemblepartdescription ?? entry?.task)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="2"
                    className="border px-3 py-4 text-center text-gray-500"
                  >
                    No tasks found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TaskInHand;
